import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import * as Yup from 'yup';
import { serviceCallApplicationInputs } from '../../inputs/service-call-application.inputs';

export const createServiceCallApplicationForm = (
  emailOptions: { value: string; label: string }[],
  emailInitValue: string,
  officialNameInitValue: string
) => {
  const email: FormInput = {
    ...serviceCallApplicationInputs.email,
    initValue: emailInitValue,
    validation: Yup.string()
      .email()
      .oneOf(emailOptions.map((option) => option.value))
      .required(),
    props: {
      ...serviceCallApplicationInputs.email.props,
      options: emailOptions,
      ...(emailInitValue ? {} : { placeholder: 'ServiceCallApplyScene:chooseEmail' }),
    },
  };

  const form: FormInput[] = [
    serviceCallApplicationInputs.businessId,
    serviceCallApplicationInputs.officialName,
    serviceCallApplicationInputs.streetAddress,
    serviceCallApplicationInputs.postalCode,
    serviceCallApplicationInputs.city,
    serviceCallApplicationInputs.contactName,
    serviceCallApplicationInputs.phone,
    email,
    serviceCallApplicationInputs.industry,
    serviceCallApplicationInputs.personnelCount,
  ];

  const created = createForm(form);

  return {
    Element: created.Element,
    meta: {
      initValues: {
        ...created.meta.initValues,
        officialName: officialNameInitValue,
      },
      validateSchema: created.meta.validateSchema.concat(
        Yup.object().shape({
          officialName: Yup.string().required(),
        })
      ),
    },
  };
};

export type ServiceCallApplicationFormBody = {
  businessId: string;
  officialName: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  contactName: string;
  phone: string;
  email: string;
  industry: string;
  personnelCount?: number | null;
};
